module.exports = __webpack_public_path__ + "static/media/2009 - 2010 theme logo.bdd368b2.jpg";